import { RegisterButton } from "./RegisterButton";
import { Breadcrumbs } from "../navigation/Breadcrumbs";
import { T } from "../../util/t";
import { EventHeaderDetails } from "./EventHeaderDetails";
import { useEventHeaderStyles } from "./useEventHeaderStyles";

export const EventHeader = ({ event }) => {
    const classes = useEventHeaderStyles();

    return (
        <div className={classes.container}>
            <Breadcrumbs
                className="no-background"
                crumbs={[
                    { text: <T>Organisations</T>, link: "/organisations" },
                    { text: event.organisation.name, link: `/${event.organisation.shortName}` }
                ]}
            />

            <EventHeaderDetails event={event} classes={classes} />
            {event.status === "upcoming" && <RegisterButton event={event} />}
        </div>
    );
};
